// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "microsite_message".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "microsite_message" table (1:1 with a DB row, on the wire). */
export const micrositeMessageAtomSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    organizationId: z.string(),
    role: z.string(),
    content: z.string(),
    toolCalls: z.unknown().nullable(),
    revisionId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=micrositeMessage.js.map